import PropTypes from 'prop-types';

export const PharmacyResults = ({
    routeResultMapped = undefined,
    supplierName = undefined,
    eligibleSuppliers = undefined,
}) =>
    routeResultMapped?.pharmacyDescriptor ? (
        <div className="padding__bottom--x-small">
            <div className="margin__bottom--medium font-semi-bold--uppercase">
                {routeResultMapped?.pharmacyDescriptor}
            </div>
            {supplierName && (
                <ul>
                    <li>{supplierName}</li>
                </ul>
            )}
            {eligibleSuppliers?.length > 0 && (
                <ul>
                    {eligibleSuppliers.map((supplier) => (
                        <li key={supplier.supplier_npi}>{supplier.supplier_name}</li>
                    ))}
                </ul>
            )}
        </div>
    ) : null;

PharmacyResults.propTypes = {
    routeResultMapped: PropTypes.shape({
        pharmacyDescriptor: PropTypes.string,
    }),
    supplierName: PropTypes.string,
    eligibleSuppliers: PropTypes.arrayOf(
        PropTypes.shape({
            supplier_npi: PropTypes.string,
            supplier_name: PropTypes.string,
        }),
    ),
};
